import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContentFormat, IPage } from '../models/page/page.model';

@Injectable({
  providedIn: 'root',
})
export class PageService {
  private httpClient = inject(HttpClient);

  private urlBase: string = 'api/pages';

  getAllPages(): Observable<IPage[]> {
    return this.httpClient.get<IPage[]>(this.urlBase);
  }

  createPage(page: IPage): Observable<HttpResponse<IPage>> {
    return this.httpClient.post<IPage>(`${this.urlBase}`, page, {
      observe: 'response',
    });
  }

  updatePage(page: IPage): Observable<IPage> {
    return this.httpClient.put<IPage>(`${this.urlBase}`, page);
  }

  deletePageById(id: number): Observable<IPage> {
    return this.httpClient.delete<IPage>(`${this.urlBase}/${id}`);
  }

  getPageById(id: number): Observable<IPage> {
    return this.httpClient.get<IPage>(`${this.urlBase}/${id}`);
  }

  getPageBySlug(slug: string): Observable<IPage> {
    return this.httpClient.get<IPage>(`${this.urlBase}/slugs/${slug}`);
  }

  getPageByIdWithConversion(id: number, convertTo: ContentFormat): Observable<IPage> {
    const params = new HttpParams().set('convertTo', convertTo);
    return this.httpClient.get<IPage>(`${this.urlBase}/${id}`, { params });
  }

  getAllPageSlugs(): Observable<string[]> {
    return this.httpClient.get<[]>(`${this.urlBase}/slugs`);
  }
}
